import { render, staticRenderFns } from "./TableOfGroups.vue?vue&type=template&id=5c23b54b&"
import script from "./TableOfGroups.vue?vue&type=script&lang=js&"
export * from "./TableOfGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports